/*
 * Module for the Payment Status report criteria page
 */
rs.module("content/reports/criteria/paymentstatuscriteria",

    [/* dependencies */],

    function () {

        // Initialize the page
        function initialize(jsSelectors, defaultPaymentDate, paymentDateCodeValue, paymentAgeCodeValue) {

            var criteria = $.js(jsSelectors.criteria);

            var reportSelect = criteria.js(jsSelectors.reportSelect);
            var paymentAgeRow = criteria.js(jsSelectors.paymentAgeRow);
            var paymentAgeInput = criteria.js(jsSelectors.paymentAgeInput);
            var paymentDateRow = criteria.js(jsSelectors.paymentDateRow);
            var paymentDateInput = criteria.js(jsSelectors.paymentDateInput);

            // register report filter option drop down change event
            reportSelect.change(filterChanged);

            // toggle controls when the DOM is ready.
            $(toggleControls);

            /*
            * On filter change, reset inputs to their default values and toggle their display.
            */
            function filterChanged() {

                // reset controls to default on selection change
                paymentAgeInput.val('0').clearErrors();
                paymentDateInput.val(defaultPaymentDate).clearErrors();

                // toggle controls
                toggleControls();
            }

            /*
            * Show or hide the appropriate filter options based on the selected code value
            */
            function toggleControls() {

                // get selected report filter option
                var selectedType = reportSelect.val();

                // toggle controls based on selection
                paymentAgeRow.toggle(selectedType == paymentAgeCodeValue);
                paymentDateRow.toggle(selectedType == paymentDateCodeValue);
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);